import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-grievance-details-popup",
  templateUrl: "./grievance-details-popup.component.html",
  styleUrls: ["./grievance-details-popup.component.scss"],
})
export class GrievanceDetailsPopupComponent implements OnInit {
  @Input() grieveanceDetailsData: any;
  @Input() actionTakenData: any;
  @Input() componentCheck: any;
  roleId: any;
  hideTable: boolean = true;
  noData: boolean = false;
  constructor() { }

  ngOnInit() {
    if (this.grieveanceDetailsData) {
      this.noData = true;
    }
    this.roleId = localStorage.getItem("roleId");
    if (this.roleId == "2") {
      this.hideTable = false;
    }
  }
}
